<div class="order mb-10 px-3 md:px-0">
  <div class="hidden lg:block">
    <div class="mb-6 flex items-center">
      <div class="mr-4 h-1 w-6 bg-primary-md-dark lg:w-12"></div>
      <div class="text-xl font-medium text-primary-darkest lg:text-3xl">
        My Orders
      </div>
    </div>
  </div>
  <!-- note: order filter -->
  <div class="mb-5" *ngIf="false">
    <swiper
      class="mySwiper flex space-x-5 text-primary-md-dark"
      [slidesPerView]="'auto'"
      [spaceBetween]="15">
      <ng-template swiperSlide class="w-fit">
        <li
          class="nav-item rounded-md border border-primary-md-dark bg-primary-lightest px-2 py-1 text-sm duration-200 ease-in-out hover:bg-primary-md-dark hover:text-white">
          <a class="nav-link">Semua</a>
        </li>
      </ng-template>
      <ng-template swiperSlide class="w-fit">
        <li
          class="nav-item rounded-md border border-primary-md-dark bg-primary-lightest px-2 py-1 text-sm duration-200 ease-in-out hover:bg-primary-md-dark hover:text-white">
          <a class="nav-link">Belum Bayar</a>
        </li>
      </ng-template>
      <ng-template swiperSlide class="w-fit">
        <li
          class="nav-item rounded-md border border-primary-md-dark bg-primary-lightest px-2 py-1 text-sm duration-200 ease-in-out hover:bg-primary-md-dark hover:text-white">
          <a class="nav-link">Sudah Bayar</a>
        </li>
      </ng-template>
      <ng-template swiperSlide class="w-fit">
        <li
          class="nav-item rounded-md border border-primary-md-dark bg-primary-lightest px-2 py-1 text-sm duration-200 ease-in-out hover:bg-primary-md-dark hover:text-white">
          <a class="nav-link">Dikemas</a>
        </li>
      </ng-template>
      <ng-template swiperSlide class="w-fit">
        <li
          class="nav-item rounded-md border border-primary-md-dark bg-primary-lightest px-2 py-1 text-sm duration-200 ease-in-out hover:bg-primary-md-dark hover:text-white">
          <a class="nav-link">Dikirim</a>
        </li>
      </ng-template>
      <ng-template swiperSlide class="w-fit">
        <li
          class="nav-item rounded-md border border-primary-md-dark bg-primary-lightest px-2 py-1 text-sm duration-200 ease-in-out hover:bg-primary-md-dark hover:text-white">
          <a class="nav-link">Selesai</a>
        </li>
      </ng-template>
      <ng-template swiperSlide class="w-fit">
        <li
          class="nav-item rounded-md border border-primary-md-dark bg-primary-lightest px-2 py-1 text-sm duration-200 ease-in-out hover:bg-primary-md-dark hover:text-white">
          <a class="nav-link">Dibatalkan</a>
        </li>
      </ng-template>
      <ng-template swiperSlide class="w-fit">
        <li
          class="nav-item rounded-md border border-primary-md-dark bg-primary-lightest px-2 py-1 text-sm duration-200 ease-in-out hover:bg-primary-md-dark hover:text-white">
          <a class="nav-link">Komplain</a>
        </li>
      </ng-template>
    </swiper>
  </div>

  <!-- <div class="filter">
    <div class="search-filter">
      <div class="p-input-wrapper search">
        <input
          type="text"
          class="p-form-control"
          placeholder="Search product, Toko atau Pesanan"
          #filter />
        <fa-icon class="icon" [icon]="faSearch"></fa-icon>
      </div>
    </div>
    <div class="date-filter"> -->
  <!-- note:need date picker -->
  <!-- <fx-datepicker (setDate)="setDateFilter($event)"></fx-datepicker> -->
  <!-- </div>
  </div> -->
  <div class="order-list space-y-5">
    <div
      class="shop-card overflow-hidden rounded-md shadow-md"
      *ngFor="let order of orders; let i = index">
      <div class="sc-header bg-primary-lightest p-3">
        <div class="content flex items-center justify-between">
          <div
            class="shop flex items-center gap-5"
            [routerLink]="['/shop', order.shop.slug]">
            <div class="shop-img-wrapper">
              <div
                class="c-img-r h-[40px] w-[40px] overflow-hidden rounded-full">
                <img
                  class="h-[40px] w-[40px]"
                  [src]="
                    order.shop.logo_path ? order.shop.logo_path : shopDefaultImg
                  "
                  [alt]="order.shop.name"
                  (error)="handleShopImgError()" />
              </div>
            </div>
            <div class="shop-info">
              <div
                class="shop-name text-lg font-bold uppercase text-primary-darkest line-clamp-1">
                {{ order.shop_name }}
              </div>
            </div>
          </div>
          <div class="c-btn-group-rtl action flex items-center gap-3">
            <button
              class="btn-detail py-1 px-3 text-primary-md-dark"
              [routerLink]="['/user/order', order.id]">
              Details
            </button>
            <!-- note: need modal buy again -->
            <!-- <button
            class="rounded-md bg-primary-md-dark py-1 px-3 text-white"
            (click)="openBuyAgainModal(order.shop_name, order.lines)">
            Beli Lagi
          </button> -->
          </div>
        </div>
      </div>
      <div class="sc-body">
        <div
          class="order-info items-center gap-3 border-b border-primary-md-dark/30 p-3 lg:flex">
          <div class="oi-item order-no flex-1">
            <div class="label text-xs uppercase text-primary-darkest/50">
              ORDER NO:
            </div>
            <div class="value text-right text-primary-md-dark lg:text-left">
              ORDER#{{ order.id }}
            </div>
          </div>
          <div class="oi-item order-date flex-1">
            <div class="label text-xs uppercase text-primary-darkest/50">
              ORDER DATE:
            </div>
            <div class="value text-right lg:text-left">
              {{ order.formatted_created_date }}
            </div>
          </div>
          <div class="oi-item status flex-1">
            <div class="label text-xs uppercase text-primary-darkest/50">
              Status:
            </div>
            <div class="value text-right lg:text-left">
              <span
                class="status-badge rounded-md bg-primary-md-dark py-0.5 px-3 text-xs text-white"
                >{{ translateOrderStatus(order.status) }}</span
              >
            </div>
          </div>
          <div class="oi-item total-order flex-1">
            <div class="label text-xs uppercase text-primary-darkest/50">
              Order Totals:
            </div>
            <div class="value text-right text-red-500 lg:text-left">
              {{ order.total | fcCurrency }}
            </div>
          </div>
        </div>
        <div class="product-list divide-y divide-primary-md-dark/30">
          <div
            class="product-item flex items-center gap-3 p-3"
            *ngFor="
              let product of order.lines
                | slice: 0:(pToggle[i] ? order.total_order_lines : 2)
            ">
            <div class="flex w-full items-center gap-3 lg:w-1/2">
              <div
                class="product-img-wrapper h-[60px] w-[60px] overflow-hidden rounded-md border border-primary-md-dark">
                <img
                  class="h-[60px] w-[60px] rounded-md"
                  [src]="
                    product.product_default_image_path &&
                    product.product_default_image_path[0].small
                      ? product.product_default_image_path[0].small.path
                      : productDefaultImg
                  "
                  [alt]="product.product_name"
                  class="product-img"
                  (error)="handleProductImgError()" />
              </div>
              <div class="product-info flex-1">
                <div class="product-name text-primary-darkest line-clamp-1">
                  {{ product.product_brand.name }} - {{ product.product_name }}
                </div>
                <div
                  class="product-variant text-xs text-primary-darkest/50"
                  *ngIf="product.product_variant_name">
                  Varian: {{ product.product_variant_name }}
                </div>
              </div>
            </div>

            <div
              class="product-price hidden flex-1 text-primary-md-dark lg:block">
              {{ product.unit_price | fcCurrency }}
            </div>
            <div
              class="product-price text-right text-primary-md-dark lg:flex-1 lg:text-left">
              {{ product.total | fcCurrency }}
              <div class="total-item text-xs text-primary-darkest/50">
                {{ product.quantity }} Pcs ({{ product.unit_weight }}gr)
              </div>
            </div>
          </div>
          <div class="see-more p-2" *ngIf="order.total_order_lines > 2">
            <div class="load-more text-center">
              <button
                class="py-1 px-3 text-primary-md-dark"
                (click)="onPToggle(i)"
                *ngIf="pToggle[i] == false">
                Lihat Selengkapnya <fa-icon [icon]="faChevronDown"></fa-icon>
              </button>
              <button
                class="py-1 px-3 text-primary-md-dark"
                (click)="onPToggle(i)"
                *ngIf="pToggle[i] == true">
                Tutup <fa-icon [icon]="faChevronUp"></fa-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="load-more mx-auto text-center" *ngIf="!hideLoadMore">
    <button
      class="rounded-md border border-primary-md-dark py-1 px-3 text-primary-md-dark"
      [ngClass]="{ 'opacity-50': loadMoreLoading }"
      (click)="loadOrders()"
      [disabled]="loadMoreLoading">
      <span class="btn-label"
        >Show more <fa-icon class="ml-1" [icon]="faChevronDown"></fa-icon
      ></span>
      <fa-icon
        class="load-icon"
        *ngIf="loadMoreLoading"
        [icon]="faSpinner"
        [spin]="true"></fa-icon>
    </button>
  </div>
</div>
